<template>
<div id="ProductFastSearch" class="product-fast-search">
  <div class="banner" :class="{'web': platform === 'web'}">
    <div class="banner-img banner-left-img">
      <img :src="bannerLeftImg" alt="" />
    </div>
    <div class="banner-img banner-right-img">
      <img :src="bannerRightImg" alt="" />
    </div>
    <div class="banner-text">
      <h1>一站式产品选型平台</h1>
      <ul class="banner-text-ul">
        <li class="banner-text-li">
          <img src="../../assets/image/productBanner/banner-icon-01.svg" alt="" />
          <span>全品类多品牌</span>
        </li>
        <li class="banner-text-li">
          <img src="../../assets/image/productBanner/banner-icon-02.svg" alt="" />
          <span>二三维都能用</span>
        </li>
        <li class="banner-text-li">
          <img src="../../assets/image/productBanner/banner-icon-03.svg" alt="" />
          <span>BIM构件一键布置</span>
        </li>
      </ul>
    </div>
  </div>
  <div class="bread-container">
    <div class="bread-content" :class="{'web': platform === 'web'}">
      <span v-if="platform !== 'g'" class="doc-entry" @click="toDoc">查找电子手册</span>
      <span class="feedback-entry" @click="toFeedback">没有我要找的品类？点击这里 >></span>
    </div>
  </div>
  <div class="main-container">
    <div class="main-content" :class="{'web': platform === 'web'}">
      <div class="main-left">
        <ul class="main-left-ul">
          <li
              v-for="item in productClassificationMenu"
              :key="item.code"
              class="main-left-li"
              :class="{'active': currentCategoryCode === item.code}"
              @click="handleClassificationChange(item)">
            <i class="icon-classification gjw-iconfont" :class="item.icon"/>
            <span>{{ item.name }}</span>
            <i v-if="item.isNew" class="gjw-iconfont gjw-icon-new2 icon-new" />
          </li>
        </ul>
      </div>
      <div class="main-right">
        <fast-search-right v-if="showRightSearch" :category-code="currentCategoryCode" :category-name="currentCategoryName" />
      </div>
    </div>
  </div>
  <div v-if="platform === 'web'" class="footer-container">
    <div class="ft-grey mg-bt-lg">京ICP备10021606号-24 广联达科技股份有限公司旗下产品</div>
    <div class="ft-grey">Copyright©2017-2021 构件坞</div>
  </div>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import envCodes from '@/assets/js/envCodes'
import bannerRight1280 from '@/assets/image/productBanner/banner-right-1280.png'
import bannerLeft1280 from '@/assets/image/productBanner/banner-left-1280.png'
import bannerRight1920 from '@/assets/image/productBanner/banner-right-1920.png'
import bannerLeft1920 from '@/assets/image/productBanner/banner-left-1920.png'
import FastSearchRight from '@/views/products/components/FastSearchRight.vue'
import checkLoginMixin from '@/mixins/checkLoginMixin'
import goToPageMixin from '@/mixins/goToPageMixin'
import { NavigateToBrowser } from '@/core/gcsUtils'

export default {
  name: 'ProductFastSearch',
  components: { FastSearchRight },
  mixins: [checkLoginMixin, goToPageMixin],
  data() {
    return {
      currentCategoryCode: '',
      currentCategoryName: '',
      showRightSearch: false
    }
  },
  computed: {
    ...mapGetters({
      platform: 'platform',
      productClassificationMenu: 'classification/productClassificationMenu'
    }),
    bannerLeftImg() {
      return this.platform === 'web' ? bannerLeft1920 : bannerLeft1280
    },
    bannerRightImg() {
      return this.platform === 'web' ? bannerRight1920 : bannerRight1280
    },
    trackInfo() {
      const info = this.$route.query.track || ''
      return info ? JSON.parse(info) : null
    }
  },
  async created() {
    await this.loadProductClassifications()
    const queryCategoryCode = this.$route.query.categoryCode
    let queryCategoryObj
    if (queryCategoryCode) {
      queryCategoryObj = this.productClassificationMenu.find((it) => it.code === queryCategoryCode)
    }
    const targetCategory = queryCategoryObj || this.productClassificationMenu[0]
    this.currentCategoryCode = targetCategory ? targetCategory.code : ''
    this.currentCategoryName = targetCategory ? targetCategory.name : ''
    this.initClassificationSearch()
  },
  methods: {
    ...mapActions({
      loadProductClassifications: 'classification/loadProductClassifications',
      loadAllProperties: 'list/loadAllProperties',
      loadBrands: 'list/loadBrands',
      loadAggProperties: 'list/loadAggProperties',
    }),
    initClassificationSearch() {
      this.showRightSearch = false
      this.loadBrands({ gjwCategoryCode: this.currentCategoryCode })
      this.loadAllProperties({ gjwCategoryCode: this.currentCategoryCode })
      const payload = {
        gjwCategoryCode: this.currentCategoryCode,
        speedControl: this.currentCategoryCode === envCodes.fanCode ? 'SINGLE_SPEED' : null
      }
      this.loadAggProperties(payload)
      this.visitTrack()
      setTimeout(() => {
        this.showRightSearch = true
      }, 100)
    },
    // 进入页面埋点
    visitTrack() {
      const trackParams = {
        event: 'visitSelectionHomePage',
        params: {
          g_c_class_code: this.currentCategoryCode,
          g_c_class_name: this.currentCategoryName,
          g_c_source: this.trackInfo,
        }
      }
      this.$tracks(trackParams)
    },
    handleClassificationChange(item) {
      this.currentCategoryCode = item.code
      this.currentCategoryName = item.name
      this.initClassificationSearch()
    },
    async toDoc() {
      const isLogin = await this.checkLogin()
      if (isLogin) {
        const routeInfo = {
          name: 'Documents'
        }
        await this.toPage(routeInfo)
      } else {
        await this.showLoginDialog()
      }
    },
    toFeedback() {
      const title = '缺品类'
      const url = encodeURI(`${process.env.VUE_APP_GJW_PORTAL_URL}/feedback?from=6&title=${title}&source=Selection`)
      if (this.platform === 'r') {
        this.$revitClient.NavigateToBrowser(url)
      } else if (this.platform === 'g') {
        NavigateToBrowser(url)
      } else if (this.platform === 'cs') {
        this.$desktopClient.NavigateToBrowser(url)
      } else {
        window.open(url, '_blank')
      }
    },
  }
}
</script>

<style lang="less" scoped>
.product-fast-search{
  flex: 1;
  display: flex;
  flex-direction: column;
}
.banner{
  position: relative;
  height: 160px;
  background: linear-gradient(122deg,#096185,#27a4c5 54%,#25ced8);
  display: flex;
  justify-content: center;
  align-items: center;
  &.web{
    height: 240px;
  }
  .banner-img{
    height: 100%;
    position: absolute;
    z-index: 1;
    top: 0;
    &.banner-left-img{
      left: 0;
    }
    &.banner-right-img{
      right: 0;
    }
  }
  .banner-text{
    z-index: 10;
    color: #FFFFFF;
    h1{
      font-size: 2.8rem;
      text-align: center;
      margin-bottom: 1rem;
    }
    .banner-text-ul{
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .banner-text-li{
      font-size: 1.2rem;
      display: flex;
      align-items: center;
      margin-right: 20px;
      img{
        margin-right: 6px;
      }
    }
  }
}
.web-content{
  width: 1310px;
  margin: 0 auto;
}
.bread-container{
  background: @bg-grey-light;
}
.bread-content{
  height: 40px;
  line-height: 40px;
  padding-right: 40px;
  text-align: right;
  color: @theme-color;
  &.web{
    .web-content;
    padding-right: 0;
  }
  .doc-entry{
    position: relative;
    margin-right: 20px;
    cursor: pointer;
    &:hover{
      color: @theme-hover-color;
    }
    &:after{
      content: '';
      position: absolute;
      top: 0;
      right: -10px;
      width: 2px;
      height: 100%;
      background: #B4B4BE;
    }
  }
  .feedback-entry{
    cursor: pointer;
    &:hover{
      color: @theme-hover-color;
    }
  }
}
.main-container{
  flex: 1;
  background: #FFFFFF;
}
.main-content{
  position: relative;
  display: flex;
  flex-direction: row;
  &.web{
    .web-content;
  }
  .main-left{
    position: relative;
    top: -56px;
    left: 20px;
    z-index: 9;
    width: 240px;
    min-height: 408px;
  }
  .main-left-ul{
    background: @bg-grey-light;
    box-shadow: 0 4px 4px 0 rgba(82, 145, 221, 0.2);
    padding: 8px 0;
  }
  .main-left-li{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
    height: 40px;
    padding: 0 8px 0 24px;
    margin-bottom: 4px;
    &:hover{
      background: @theme-select-bg;
    }
    &.active{
      color: @theme-color;
      background: @theme-select-bg;
    }
  }
  .icon-classification{
    font-size: 1.7rem;
    margin-right: 6px;
  }
  .icon-new{
    color: @theme-orange;
    font-size: 2.1rem;
    margin-left: 6px;
  }
  .main-right{
    flex: 1;
    padding: 16px 24px 16px 40px;
  }
}
.footer-container{
  padding: 40px 0;
  text-align: center;
}
</style>
